import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getUserContext } from "../services/user-context";
import { useLocale } from "../stores/locale";

export function useGetAuthContext() {
  const { currentLanguage } = useLocale();

  return useQuery({
    queryKey: ["auth-context", currentLanguage],
    queryFn: async () => getUserContext(currentLanguage),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
